export enum Global {
    DEFAULT_LAYOUT = 'standalone',
    DEALER_LAYOUT = 'dealer',
    TEASER_LAYOUT = 'teaser',
    DEFAULT_BRAND = 'VW',
    ERROR_422 = 422,
    ERROR_404 = 404,
    MINiMUM_FORM_FIELD_LENGTH = 2,
    PLATE = 'plate',
    NATIONAL_KEY = 'national',
    DW_SW_KEY = 'dw_sw',
    DEALER_WEB_SOURCE = 'dw',
    SERVICE_WEB_SOURCE = 'sw',
    CYCLE_ID_LENGTH = 12,
}

export enum Params {
    ACTIVITY_TYPE = 'activityType',
    BEARER = 'bearer',
    BRAND = 'brand',
    CLEANED_COMPANY = 'cleanedCompany',
    COMPANY_CODE = 'companyCode',
    CONTRACT_TYPE = 'contractType',
    DEALER = 'dealer',
    DEALERS = 'dealers',
    NOT_COMPANY_CODES = 'not_company_codes',
    ORDER_BY = 'orderby',
    PROMOTIONS = 'promotions',
    PROVINCES = 'provinces',
}

export enum Endpoints {
    COUPONS = 'coupons',
    EMAIL = 'email',
}

export const LIMIT_TEXT_AREA = 250

export enum IdkEndpoints {
    CSRF_TOKEN = 'csrf_token',
    USER = '/user',
}

export enum InputStyle {
    Default = 'default',
    Information = 'information',
    Disabled = 'disabled',
    Error = 'error',
    Success = 'success',
    ReadOnly = 'readonly',
    Validation = 'validation',
}

export enum InfoboxStyle {
    Default = 'default',
    Error = 'error',
    Success = 'success',
}
